const Session = require('./session');

var apiBaseUrl = getApiBaseUrl();

function getFullUrl(methodUrl) {
    return apiBaseUrl + methodUrl;
}

function getFetchConfig(method, data, signal) {
    var body = null;
    var headers = {};

    if (data instanceof FormData) {
        body = data;
    } else {
        if (data) {
            body = JSON.stringify(data);
        }
        headers['Content-Type'] = 'application/json; charset=utf-8';
    }

    return {
        signal,
        body: body,
        method: method,
        headers: headers,
        credentials: 'include',
        mode: 'cors'
    };
}

function apiGetInner(methodUrl) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('GET'))
        .then(catch401)
        .then(resolveJson);
}

function apiPostInner(methodUrl, data = {}, signal) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data, signal))
        .then(catch401)
        .then(resolveJson);
}

function apiDownloadInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('POST', data))
        .then(catch401)
        .then(catch400)
        .then(d => {
                return d.blob().then(res => (
                    {
                        data: res,
                        headers: {"content-disposition": d.headers.get('Content-Disposition')}
                    }
                ))
            }
        );
}

function apiPutInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('PUT', data))
        .then(catch401)
        .then(resolveJson);
}

function apiDeleteInner(methodUrl, data = {}) {
    return fetch(getFullUrl(methodUrl), getFetchConfig('DELETE', data))
        .then(catch401)
        .then(resolveJson);
}

function rejectUploadError(status, statusText, result) {
    if (!result || (typeof result === 'string' && result.trim() === '')) {
        if (status === 403) {
            return { Error: 'Недостаточно прав для выполнения операции' };
        }
        if (status === 404) {
            return { Error: 'Ресурс не найден' };
        }
        return { Error: `Ошибка ${status}: ${statusText || 'Unknown error'}` };
    }
    return result;
}

function apiUploadFile(methodUrl, file, fieldName, options) {
    if (file && typeof fieldName === 'object' && fieldName !== null && !Array.isArray(fieldName)) {
        options = fieldName;
        fieldName = 'file';
    }
    options = options || {};
    fieldName = fieldName || 'file';

    return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest();
        const formData = new FormData();
        formData.append(fieldName, file);

        xhr.open('POST', getFullUrl(methodUrl), true);
        xhr.withCredentials = true;

        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable && options.onProgress) {
                options.onProgress(Math.round((event.loaded / event.total) * 100));
            }
        };

        xhr.onload = () => {
            if (xhr.status === 401) {
                stopApiSession();
                reject('Unauthorized');
                return;
            }

            const result = convertJson(xhr.responseText);
            if (xhr.status >= 400) {
                reject(rejectUploadError(xhr.status, xhr.statusText, result));
                return;
            }
            resolve(result);
        };

        xhr.onerror = () => {
            reject({ message: 'NetworkError when attempting to fetch resource.' });
        };

        xhr.onabort = () => {
            reject({ aborted: true });
        };

        if (options.signal) {
            if (options.signal.aborted) {
                reject({ aborted: true });
                return;
            }
            options.signal.addEventListener('abort', () => xhr.abort(), { once: true });
        }

        xhr.send(formData);
    });
}

function catch401(response) {
    if (response.status === 401) {
        stopApiSession();
        return Promise.reject("Unauthorized");
    }
    if (response.status > 401) {
        return Promise.reject(response);
    }
    return Promise.resolve(response);
}

function catch400(response) {
    if (response.status === 400) {
        return response.text()
            .then(text => {
                return Promise.reject(convertJson(text));
            });
    } else {
        return Promise.resolve(response);
    }
}

function convertJson(text) {
    try {
        return JSON.parse(text);
    } catch (err) {
        return text;
    }
}

function resolveJson(response) {
    return response.text()
        .then(text => {
            let result = convertJson(text);
            if (!response.ok) {
                // Если ответ пустой или не JSON, создаем объект ошибки с информацией о статусе
                if (!result || (typeof result === 'string' && result.trim() === '')) {
                    let statusText = response.statusText || 'Unknown error';
                    if (response.status === 403) {
                        result = { Error: 'Недостаточно прав для выполнения операции' };
                    } else if (response.status === 404) {
                        result = { Error: 'Ресурс не найден' };
                    } else {
                        result = { Error: `Ошибка ${response.status}: ${statusText}` };
                    }
                }
                return Promise.reject(result);
            }
            return result;
        });
}

function validateToken() {
    if (Session.isAnonymousAllowed()) {
        return Promise.resolve(true);
    } else {
        return apiGetInner('auth/check')
            .then(() => {
                return Promise.resolve(true);
            });
    }
}

function stopApiSession(needLogout) {
    Session.stopSession(needLogout);
}

function apiGet(methodUrl) {
    return apiGetInner(methodUrl);
}

function apiPost(methodUrl, data = {}, signal) {
    return apiPostInner(methodUrl, data, signal);
}

function apiDownload(methodUrl, data = {}) {
    return apiDownloadInner(methodUrl, data);
}

function apiPut(methodUrl, data = {}) {
    return apiPutInner(methodUrl, data);
}

function apiDelete(methodUrl, data = {}) {
    return apiDeleteInner(methodUrl, data);
}

module.exports = {
    validateToken: validateToken,
    stopApiSession: stopApiSession,
    apiGet: apiGet,
    apiPost: apiPost,
    apiPut: apiPut,
    apiDelete: apiDelete,
    apiDownload,
    apiUploadFile
};


// WEBPACK FOOTER //
// ./App/services/apiClient.js